import moment from 'moment-timezone';
import { saveAs } from 'file-saver';
import { put, select, retry, all, call } from 'redux-saga/effects';
import { buildGetParamsObject, reject, resolve } from '../api';
import * as types from '../constants';
import { authClient } from '../api/Client';
import humps from 'humps';
import { getFilterProfile, getSortOrder } from '../selectors/ioc';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  infoNotification,
  showNotification,
  successNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';
import profile from '../../containers/ProfileContainer/components/Profile';
import {
  loadMergeAPIExploreRecipes as loadMergeAPIExploreRecipesAction,
  loadMergeAPIExploreQueryBuilderSchemas as loadMergeAPIExploreQueryBuilderSchemasAction,
  loadAttackSurfaceMapping as loadAttackSurfaceMappingAction,
  loadDigitalThreatManagement as loadDigitalThreatManagementAction,
} from '../actions/ioc';
import history from '../history';

export function* updateIocList({
  pagination,
  filters,
  sorting,
  filterProfile,
  distinct,
  tag,
  feed_state,
}) {
  try {
    const sortOrder = yield select(getSortOrder);
    const stateFilterProfile = yield select(getFilterProfile);
    // const profileToApply = filterProfile || stateFilterProfile;
    const profileToApply = filterProfile;
    const params = buildGetParamsObject({
      pagination,
      filters,
      sorting,
      distinct,
      sortOrder,
      filterProfile: profileToApply,
    });
    if (tag) {
      params.tags = tag;
    }
    if (feed_state) {
      params.state = feed_state;
    }
    let res;
    let iocList = [];
    if (!profileToApply || typeof profileToApply === 'string') {
      res = yield retry(4, 500, authClient.IOC.list, {
        ...params,
      });
      iocList = res.data();
    } else if (typeof profileToApply === 'object' && profileToApply) {
      res = yield retry(4, 500, authClient.IOC.applyFilterProfile, {
        ...params,
      });
      iocList = res.data();
    }
    yield put({
      type: resolve(types?.UPDATE_IOC_LIST),
      payload: humps?.camelizeKeys(iocList),
      // total: response?.count,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.UPDATE_IOC_LIST),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.UPDATE_IOC_LIST)),
      }),
    ]);
  }
}

export function* updateIocListFromCache({
  pagination,
  filters,
  sorting,
  filterProfile,
  distinct,
  tag,
  feed_state,
}) {
  try {
    const sortOrder = yield select(getSortOrder);
    const stateFilterProfile = yield select(getFilterProfile);
    // const profileToApply = filterProfile || stateFilterProfile;
    const profileToApply = filterProfile;
    const params = buildGetParamsObject({
      pagination,
      filters,
      sorting,
      distinct,
      sortOrder,
      filterProfile: profileToApply,
    });
    if (tag) {
      params.tags = tag;
    }
    if (feed_state) {
      params.state = feed_state;
    }
    let res;
    let iocList = [];
    if (!profileToApply || typeof profileToApply === 'string') {
      //res = yield retry(4, 500, authClient.IOC.list, {
      //  ...params,
      //});
      //iocList = res.data();
    } else if (typeof profileToApply === 'object' && profileToApply) {
      //  res = yield retry(4, 500, authClient.IOC.applyFilterProfile, {
      //   ...params,
      // });
      // iocList = res.data();
    }
    yield put({
      type: resolve(types?.UPDATE_IOC_LIST_FROM_CACHE),
      // payload: humps?.camelizeKeys(iocList),
      // total: response?.count,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.UPDATE_IOC_LIST_FROM_CACHE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.UPDATE_IOC_LIST_FROM_CACHE),
        ),
      }),
    ]);
  }
}

export function* paginationIocList({
  pagination,
  filters,
  sorting,
  filterProfile,
  distinct,
  tag,
  feed_state,
}) {
  try {
    const sortOrder = yield select(getSortOrder);
    const stateFilterProfile = yield select(getFilterProfile);
    // const profileToApply = filterProfile || stateFilterProfile;
    const profileToApply = filterProfile;
    const params = buildGetParamsObject({
      pagination,
      filters,
      sorting,
      distinct,
      sortOrder,
      filterProfile: profileToApply,
    });
    if (tag) {
      params.tags = tag;
    }
    if (feed_state) {
      params.state = feed_state;
    }
    let res;
    if (!profileToApply || typeof profileToApply === 'string') {
      res = yield retry(4, 500, authClient.IOC.pagination, {
        ...params,
      });
    } else if (typeof profileToApply === 'object' && profileToApply) {
      res = yield retry(4, 500, authClient.IOC.applyFilterProfileCount, {
        ...params,
      });
    }
    const response = res?.data();
    yield put({
      type: resolve(types?.PAGINATION_IOC_LIST),
      payload: humps?.camelizeKeys(response),
      total: response?.count,
      next: response?.next,
      previous: response?.previous,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.PAGINATION_IOC_LIST),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.PAGINATION_IOC_LIST),
        ),
      }),
    ]);
  }
}

export function* paginationIocListFromCache({
  pagination,
  filters,
  sorting,
  filterProfile,
  distinct,
  tag,
  feed_state,
}) {
  try {
    const sortOrder = yield select(getSortOrder);
    const stateFilterProfile = yield select(getFilterProfile);
    // const profileToApply = filterProfile || stateFilterProfile;
    const profileToApply = filterProfile;
    const params = buildGetParamsObject({
      pagination,
      filters,
      sorting,
      distinct,
      sortOrder,
      filterProfile: profileToApply,
    });
    if (tag) {
      params.tags = tag;
    }
    if (feed_state) {
      params.state = feed_state;
    }
    let res;
    if (!profileToApply || typeof profileToApply === 'string') {
      // res = yield retry(4, 500, authClient.IOC.pagination, {
      //   ...params,
      // });
    } else if (typeof profileToApply === 'object' && profileToApply) {
      //  res = yield retry(4, 500, authClient.IOC.applyFilterProfileCount, {
      //    ...params,
      //  });
    }
    //const response = res?.data();
    yield put({
      type: resolve(types?.PAGINATION_IOC_LIST_FROM_CACHE),
      // payload: humps?.camelizeKeys(response),
      // total: response?.count,
      // next: response?.next,
      // previous: response?.previous,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.PAGINATION_IOC_LIST_FROM_CACHE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.PAGINATION_IOC_LIST_FROM_CACHE),
        ),
      }),
    ]);
  }
}

export function* exportListToCSV({ params, loadAdvanced, limit, total }) {
  try {
    const apiEndpoint = loadAdvanced
      ? authClient?.IOC?.exportFull
      : authClient?.IOC?.export;

    const sortOrder = yield select(getSortOrder);
    const filterProfile = yield select(getFilterProfile);
    const paramsObject = buildGetParamsObject(
      { ...params, sortOrder, filterProfile },
      limit !== '' ? limit : 100,
    );
    const res = yield retry(4, 500, apiEndpoint, {
      ...paramsObject,
    });

    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.EXPORT_LIST_TO_CSV),
        // payload: res?.data()?.message,
      });
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_LIST_TO_CSV),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Data export was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.EXPORT_LIST_TO_CSV),
  //     // payload: response,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_LIST_TO_CSV),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.EXPORT_LIST_TO_CSV),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportListToSplunk({ params, loadAdvanced, limit }) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Export is being prepared.',
      }),
    );
    const apiEndpoint = loadAdvanced
      ? authClient?.IOC?.exportToSplunk
      : authClient?.IOC?.exportToSplunk;

    const sortOrder = yield select(getSortOrder);
    const filterProfile = yield select(getFilterProfile);
    const paramsObject = buildGetParamsObject(
      { ...params, sortOrder, filterProfile },
      limit,
    );
    const res = yield retry(4, 500, apiEndpoint, {
      ...paramsObject,
    });
    // eslint-disable-next-line no-unused-vars

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.EXPORT_LIST_TO_SPLUNK),
        // payload: res?.data()?.message,
      });
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_LIST_TO_SPLUNK),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Data export was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.EXPORT_LIST_TO_SPLUNK),
  //     // payload: response,
  //   });

  //   //saveAs(
  //   //  response,
  //   //  'export_' + moment()?.format('YYYY-MM-DD_HHmmss')?.toString() + '.csv',
  //   //);
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_LIST_TO_SPLUNK),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.EXPORT_LIST_TO_SPLUNK),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportListToSTIX({ params, loadAdvanced, limit, total }) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );

    const sortOrder = yield select(getSortOrder);
    const filterProfile = yield select(getFilterProfile);
    const paramsObject = buildGetParamsObject(
      { ...params, sortOrder, filterProfile },
      limit !== '' ? limit : 100,
    );
    const res = yield retry(4, 500, authClient?.IOC?.exportToSTIX, {
      ...paramsObject,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.EXPORT_LIST_TO_STIX),
        // payload: res?.data()?.message,
      });
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_LIST_TO_STIX),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Data export was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.EXPORT_LIST_TO_STIX),
  //     // payload: response,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_LIST_TO_STIX),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.EXPORT_LIST_TO_STIX),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportListToSTIXLimited({ params, limit = 100 }) {
  try {
    const sortOrder = yield select(getSortOrder);
    const filterProfile = yield select(getFilterProfile);
    const paramsObject = buildGetParamsObject(
      { ...params, sortOrder, filterProfile },
      limit !== '' ? limit : 100,
    );
    const res = yield retry(4, 500, authClient?.IOC?.exportToSTIXLimited, {
      ...paramsObject,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.EXPORT_LIST_TO_STIX_LIMITED),
        payload: res?.data(),
      });
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_LIST_TO_STIX_LIMITED),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Data export was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.EXPORT_LIST_TO_STIX_LIMITED),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_LIST_TO_STIX_LIMITED),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.EXPORT_LIST_TO_STIX_LIMITED),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportListToJSON({ params, loadAdvanced, limit, total }) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    const apiEndpoint = loadAdvanced
      ? authClient?.IOC?.exportFullJSON
      : authClient?.IOC?.exportJSON;

    const sortOrder = yield select(getSortOrder);
    const filterProfile = yield select(getFilterProfile);
    const paramsObject = buildGetParamsObject(
      { ...params, sortOrder, filterProfile },
      limit !== '' ? limit : 100,
    );
    const res = yield retry(4, 500, apiEndpoint, {
      ...paramsObject,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.EXPORT_LIST_TO_JSON),
        // payload: res?.data(),
      });
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_LIST_TO_JSON),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Data export was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.EXPORT_LIST_TO_JSON),
  //     // payload: response,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_LIST_TO_JSON),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.EXPORT_LIST_TO_JSON),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportSingleIOC({ uuid }) {
  try {
    //showMessage({ content: 'Export is being prepared.' });
    // const apiEndpoint = loadAdvanced
    //   ? authClient.IOC.exportSingleIOC
    //   : authClient.IOC.exportSingleIOC;

    // const sortOrder = yield select(getSortOrder);
    // const filterProfile = yield select(getFilterProfile);
    // const paramsObject = buildGetParamsObject(
    //   { ...params, sortOrder, filterProfile },
    //   limit,
    // );
    const res = yield retry(4, 500, authClient?.IOC?.exportSingleIOC, {
      uuid,
      type: 'csv',
    });
    const response = res?.data();

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.EXPORT_SINGLE_IOC),
        // payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Export Successful.',
        }),
      );
      saveAs(
        response,
        'export_' + moment()?.format('YYYY-MM-DD_HHmmss')?.toString() + '.csv',
      );
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_SINGLE_IOC),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Exporting observable was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   // console.log('RESP', response);
  //   yield put({
  //     type: resolve(types?.EXPORT_SINGLE_IOC),
  //     // payload: response,
  //   });

  //   saveAs(
  //     response,
  //     'export_' + moment()?.format('YYYY-MM-DD_HHmmss')?.toString() + '.csv',
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_SINGLE_IOC),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.EXPORT_SINGLE_IOC),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportExploreResultToCSV({ path, limit, sort, filter }) {
  let pathPlusParams = path;

  if (filter?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      filter?.['last_seen_from']?.substr(0, 10);
  }
  if (filter?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      filter?.['last_seen_to']?.substr(0, 10);
  }
  if (filter?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      filter?.['first_seen_from']?.substr(0, 10);
  }
  if (filter?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      filter?.['first_seen_to']?.substr(0, 10);
  }
  if (sort !== null && sort !== undefined && Object.keys(sort)?.length !== 0) {
    // console.log('ITTVAGYOK');
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(sort);
  }

  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    const res = yield retry(4, 500, authClient?.IOC?.exportExploreResultToCSV, {
      path: pathPlusParams,
      // limit,
      // sort,
      // filter,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.EXPORT_EXPLORE_RESULT_TO_CSV),
        // payload: res?.data(),
      });
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_EXPLORE_RESULT_TO_CSV),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Exporting data was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.EXPORT_EXPLORE_RESULT_TO_CSV),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_EXPLORE_RESULT_TO_CSV),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.EXPORT_EXPLORE_RESULT_TO_CSV),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportExploreResultToJSON({ path, limit, sort, filter }) {
  let pathPlusParams = path;
  //  if (limit) {

  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('?') ? '&' : '?') +
  //   'limit=' +
  //   (limit ? limit : '100');

  // }
  // console.log('afterfirstAdd',pathPlusParams)
  if (filter?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      filter?.['last_seen_from']?.substr(0, 10);
  }
  if (filter?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      filter?.['last_seen_to']?.substr(0, 10);
  }
  if (filter?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      filter?.['first_seen_from']?.substr(0, 10);
  }
  if (filter?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      filter?.['first_seen_to']?.substr(0, 10);
  }
  if (sort !== null && sort !== undefined && Object.keys(sort)?.length !== 0) {
    // console.log('ITTVAGYOK');
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(sort);
  }

  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.exportExploreResultToJSON,
      {
        path: pathPlusParams,
        // limit,
        // sort,
        // filter,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.EXPORT_EXPLORE_RESULT_TO_JSON),
        // payload: res?.data(),
      });
    } else {
      yield all([
        put({
          type: reject(types?.EXPORT_EXPLORE_RESULT_TO_JSON),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Exporting data was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.EXPORT_EXPLORE_RESULT_TO_JSON),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.EXPORT_EXPLORE_RESULT_TO_JSON),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.EXPORT_EXPLORE_RESULT_TO_JSON),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* exportSpoofingToCSV({
  domain,
  regex,
  name_servers,
  is_nameserver_in,
  additional_networks,
  is_network_in,
  as_numbers,
  is_asn_in,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
}) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportSpoofingToCSV, {
      body: {
        domain,
        regex,
        name_servers,
        is_nameserver_in,
        additional_networks,
        is_network_in,
        as_numbers,
        is_asn_in,
        first_seen_before,
        first_seen_after,
        last_seen_before,
        last_seen_after,
        limit,
        sort,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_SPOOFING_TO_CSV),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_SPOOFING_TO_CSV),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_SPOOFING_TO_CSV),
        ),
      }),
    ]);
  }
}

export function* exportSpoofingToJSON({
  domain,
  regex,
  name_servers,
  is_nameserver_in,
  additional_networks,
  is_network_in,
  as_numbers,
  is_asn_in,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
}) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportSpoofingToJSON, {
      body: {
        domain,
        regex,
        name_servers,
        is_nameserver_in,
        additional_networks,
        is_network_in,
        as_numbers,
        is_asn_in,
        first_seen_before,
        first_seen_after,
        last_seen_before,
        last_seen_after,
        limit,
        sort,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_SPOOFING_TO_JSON),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_SPOOFING_TO_JSON),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_SPOOFING_TO_JSON),
        ),
      }),
    ]);
  }
}

export function* exportDanglingDNSToCSV({ record_type, source, limit, sort }) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportDanglingDNSToCSV, {
      body: {
        record_type,
        source,
        limit,
        sort,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_DANGLING_DNS_TO_CSV),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_DANGLING_DNS_TO_CSV),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_DANGLING_DNS_TO_CSV),
        ),
      }),
    ]);
  }
}

export function* exportDanglingDNSToJSON({ record_type, source, limit, sort }) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportDanglingDNSToJSON, {
      body: {
        record_type,
        source,
        limit,
        sort,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_DANGLING_DNS_TO_JSON),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_DANGLING_DNS_TO_JSON),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_DANGLING_DNS_TO_JSON),
        ),
      }),
    ]);
  }
}

export function* exportHostingInfrasctructureASNsToCSV({
  result_format,
  domain,
  limit,
}) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportHostingInfrastructureASNsToCSV, {
      body: {
        result_format,
        domain,
        limit,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_CSV),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_CSV),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_CSV),
        ),
      }),
    ]);
  }
}

export function* exportHostingInfrasctructureASNsToJSON({
  result_format,
  domain,
  limit,
}) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(
      4,
      500,
      authClient?.IOC?.exportHostingInfrastructureASNsToJSON,
      {
        body: {
          result_format,
          domain,
          limit,
        },
      },
    );
    yield put({
      type: resolve(types?.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_JSON),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_JSON),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_JSON),
        ),
      }),
    ]);
  }
}

export function* exportShadowITtoCSV({
  domain,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
}) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportShadowITtoCSV, {
      body: {
        domain,
        first_seen_before,
        first_seen_after,
        last_seen_before,
        last_seen_after,
        limit,
        sort,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_SHADOW_IT_TO_CSV),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_SHADOW_IT_TO_CSV),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_SHADOW_IT_TO_CSV),
        ),
      }),
    ]);
  }
}

export function* exportShadowITtoJSON({
  domain,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
}) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportShadowITtoJSON, {
      body: {
        domain,
        first_seen_before,
        first_seen_after,
        last_seen_before,
        last_seen_after,
        limit,
        sort,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_SHADOW_IT_TO_JSON),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_SHADOW_IT_TO_JSON),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_SHADOW_IT_TO_JSON),
        ),
      }),
    ]);
  }
}

export function* exportSubdomainFinderToCSV({
  domain,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
}) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportSubdomainFinderToCSV, {
      body: {
        domain,
        first_seen_before,
        first_seen_after,
        last_seen_before,
        last_seen_after,
        limit,
        sort,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_SUBDOMAIN_FINDER_TO_CSV),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_SUBDOMAIN_FINDER_TO_CSV),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_SUBDOMAIN_FINDER_TO_CSV),
        ),
      }),
    ]);
  }
}

export function* exportSubdomainFinderToJSON({
  domain,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
}) {
  try {
    showNotification(
      infoNotification({
        statusCode: 100,
        message:
          'Your data is being prepared. When the file is ready, you will receive an email to download the data.',
      }),
    );
    yield retry(4, 500, authClient?.IOC?.exportSubdomainFinderToJSON, {
      body: {
        domain,
        first_seen_before,
        first_seen_after,
        last_seen_before,
        last_seen_after,
        limit,
        sort,
      },
    });
    yield put({
      type: resolve(types?.EXPORT_SUBDOMAIN_FINDER_TO_JSON),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.EXPORT_SUBDOMAIN_FINDER_TO_JSON),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.EXPORT_SUBDOMAIN_FINDER_TO_JSON),
        ),
      }),
    ]);
  }
}

export function* clearScoreDetails() {
  try {
    //const res = yield retry(4, 500, authClient.IOC.details, {});
    yield put({
      type: resolve(types?.CLEAR_SCORE_DETAILS),
      //payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.CLEAR_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.CLEAR_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadScoreDetails({ id }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.details, {
      id,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_SCORE_DETAILS),
        payload: res?.data(),
      });
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_SCORE_DETAILS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading Observable details was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_SCORE_DETAILS),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_SCORE_DETAILS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_SCORE_DETAILS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadNewScoreDetails({ feed_uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.newDetails, { feed_uuid });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_NEW_SCORE_DETAILS),
        payload: res?.data().response,
      });
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_NEW_SCORE_DETAILS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading Observable details was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_NEW_SCORE_DETAILS),
  //     payload: res?.data().response,
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_NEW_SCORE_DETAILS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_NEW_SCORE_DETAILS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIEnrichment({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiEnrichment, {
      body: data,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadMergeAPINewEnrichment({ name, iocType }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiNewEnrichment, {
      name,
      iocType,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadUtilsParseIOC({ ioc }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadUtilsParseIOC, {
      body: ioc,
    });
    yield put({
      type: resolve(types?.LOAD_UTILS_PARSE_IOC),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_UTILS_PARSE_IOC),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_UTILS_PARSE_IOC),
        ),
      }),
    ]);
  }
}

export function* loadMergeAPIDomainDetails({ domain }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiDomain, {
      domain,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_DOMAIN_SCORE_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_DOMAIN_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_DOMAIN_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadMergeAPIIPDetails({ ip }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiIp, {
      ip,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_IP_SCORE_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_IP_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_IP_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* clearExploreDetails() {
  try {
    //const res = yield retry(4, 500, authClient.IOC.details, {});
    yield put({
      type: resolve(types?.CLEAR_EXPLORE_SCORE_DETAILS),
      //payload: res.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.CLEAR_EXPLORE_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.CLEAR_EXPLORE_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadMergeAPIDomainInfraTags({ domain, is_voluntary }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiDomainInfraTags, {
      domain,
      is_voluntary,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_DOMAIN_INFRA_TAGS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_DOMAIN_INFRA_TAGS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_DOMAIN_INFRA_TAGS),
        ),
      }),
    ]);
  }
}

export function* loadHostingInfrastructureASNData({ path, exploreFilters }) {
  let pathPlusParams = path?.path;

  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  pathPlusParams = finalURLPathName + '?' + URLParams?.toString();

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();

    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(path?.exploreSorting);
  }

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('max_wait')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('with_metadata')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadHostingInfrastructureASNData,
      {
        path: pathPlusParams,
      },
    );
    yield put({
      type: resolve(types?.LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA),
        ),
      }),
    ]);
  }
}

export function* loadDanglingDNSRecordsCountData({ path, exploreFilters }) {
  let pathPlusParams = path?.path;

  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  pathPlusParams = finalURLPathName + '?' + URLParams?.toString();

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();

    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(path?.exploreSorting);
  }

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('max_wait')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('with_metadata')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadDanglingDNSRecordsCountData,
      {
        path: pathPlusParams,
      },
    );
    yield put({
      type: resolve(types?.LOAD_DANGLING_DNS_RECORDS_COUNT_DATA),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_DANGLING_DNS_RECORDS_COUNT_DATA),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_DANGLING_DNS_RECORDS_COUNT_DATA),
        ),
      }),
    ]);
  }
}

export function* loadDanglingDNSProtectionData({ path, exploreFilters }) {
  let pathPlusParams = path?.path;

  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  pathPlusParams = finalURLPathName + '?' + URLParams?.toString();

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();

    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(path?.exploreSorting);
  }

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('max_wait')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('with_metadata')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadDanglingDNSProtectionData,
      {
        path: pathPlusParams,
      },
    );
    yield put({
      type: resolve(types?.LOAD_DANGLING_DNS_PROTECTION_DATA),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_DANGLING_DNS_PROTECTION_DATA),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_DANGLING_DNS_PROTECTION_DATA),
        ),
      }),
    ]);
  }
}

export function* loadMergeAPIExploreDetails({ path, exploreFilters }) {
  let pathPlusParams = path?.path;
  // console.log('begin', pathPlusParams);
  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  /*
  NOT FULLY SUPPORTED: URLParams.size
  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/size
   */
  if (URLParams?.size > 0 || URLParams.toString() !== '') {
    pathPlusParams = finalURLPathName + '?' + URLParams?.toString();
  } else {
    pathPlusParams = finalURLPathName;
  }

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();
    // console.log('assembledURL', assembledURLForExplore);
    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(path?.exploreSorting);
  }
  // console.log('pathPlusParams', pathPlusParams);
  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('max_wait')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('with_metadata')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiExplore, {
      path: pathPlusParams,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_SCORE_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadNameServerAutoFill({ path, exploreFilters }) {
  let pathPlusParams = path?.path;
  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    // console.log('ITTVAGYOK');
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(path?.exploreSorting);
  }

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('max_wait')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('with_metadata')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadNameServerAutoFill, {
      path: pathPlusParams,
    });
    yield put({
      type: resolve(types?.LOAD_NAME_SERVER_AUTOFILL),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_NAME_SERVER_AUTOFILL),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_NAME_SERVER_AUTOFILL),
        ),
      }),
    ]);
  }
}

export function* loadDnsRecords({ path }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadDnsRecords, {
      path: path.path,
    });
    yield put({
      type: resolve(types?.LOAD_DNS_RECORDS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_DNS_RECORDS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_DNS_RECORDS)),
      }),
    ]);
  }
}

export function* loadARecordsDomainEnrichment({ path }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadARecordsDomainEnrichment,
      {
        path: path.path,
      },
    );
    yield put({
      type: resolve(types?.LOAD_A_RECORDS_DOMAIN_ENRICHMENT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_A_RECORDS_DOMAIN_ENRICHMENT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_A_RECORDS_DOMAIN_ENRICHMENT),
        ),
      }),
    ]);
  }
}

export function* loadAAAARecordsDomainEnrichment({ path }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadAAAARecordsDomainEnrichment,
      {
        path: path.path,
      },
    );
    yield put({
      type: resolve(types?.LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT),
        ),
      }),
    ]);
  }
}

export function* loadCNAMERecordsDomainEnrichment({ path }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadCNAMERecordsDomainEnrichment,
      {
        path: path.path,
      },
    );
    yield put({
      type: resolve(types?.LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT),
        ),
      }),
    ]);
  }
}

export function* loadMXRecordsDomainEnrichment({ path }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadMXRecordsDomainEnrichment,
      {
        path: path.path,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MX_RECORDS_DOMAIN_ENRICHMENT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MX_RECORDS_DOMAIN_ENRICHMENT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MX_RECORDS_DOMAIN_ENRICHMENT),
        ),
      }),
    ]);
  }
}

export function* loadNSRecordsDomainEnrichment({ path }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadNSRecordsDomainEnrichment,
      {
        path: path.path,
      },
    );
    yield put({
      type: resolve(types?.LOAD_NS_RECORDS_DOMAIN_ENRICHMENT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_NS_RECORDS_DOMAIN_ENRICHMENT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_NS_RECORDS_DOMAIN_ENRICHMENT),
        ),
      }),
    ]);
  }
}

export function* loadSOARecordsDomainEnrichment({ path }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadSOARecordsDomainEnrichment,
      {
        path: path.path,
      },
    );
    yield put({
      type: resolve(types?.LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT),
        ),
      }),
    ]);
  }
}

export function* loadTXTRecordsDomainEnrichment({ path }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadTXTRecordsDomainEnrichment,
      {
        path: path.path,
      },
    );
    yield put({
      type: resolve(types?.LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT),
        ),
      }),
    ]);
  }
}

export function* loadIpDensity({ ip, iocType, is_voluntary }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadIpDensity, {
      ip,
      iocType,
      is_voluntary,
    });
    yield put({
      type: resolve(types?.LOAD_IP_DENSITY),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_IP_DENSITY),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_IP_DENSITY)),
      }),
    ]);
  }
}

export function* loadPTRLookup({ ip, iocType, is_voluntary }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadPTRLookup, {
      ip,
      iocType,
      is_voluntary,
    });
    yield put({
      type: resolve(types?.LOAD_PTR_LOOKUP),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_PTR_LOOKUP),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_PTR_LOOKUP)),
      }),
    ]);
  }
}

export function* loadASNAutoFill({ path, exploreFilters }) {
  let pathPlusParams = path?.path;

  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadASNAutoFill, {
      path: pathPlusParams,
    });
    yield put({
      type: resolve(types?.LOAD_ASN_AUTOFILL),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_ASN_AUTOFILL),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_ASN_AUTOFILL),
        ),
      }),
    ]);
  }
}

export function* postMergeAPIExploreDetails({ data }) {
  try {
    const res = yield retry(4, 500, authClient.IOC.mergeApiExplorePost, {
      body: {
        [data?.fieldName]: data[data?.fieldName],
        ...(data?.secondFieldName && {
          [data?.secondFieldName]: data[data?.secondFieldName],
        }),
      },
      path: data.path,
    });
    yield put({
      type: resolve(types.POST_MERGE_API_EXPLORE_SCORE_DETAILS),
      payload: res.data(),
    });
  } catch (error) {
    console.log(error.toString());
    yield put({
      type: reject(types.POST_MERGE_API_EXPLORE_SCORE_DETAILS),
      error,
    });
  }
}

export function* loadMergeAPIMergeDetails({ path, exploreFilters }) {
  // console.log('path', path);
  // console.log('exploreFiltersFromSaga', path?.exploreFilters);
  // console.log('exploreSortingFromSaga', path?.exploreSorting);
  let pathPlusParams = path?.path;
  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    // console.log('ITTVAGYOK');
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(path?.exploreSorting);
  }

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('max_wait')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  pathPlusParams =
    pathPlusParams +
    (pathPlusParams.includes('with_metadata')
      ? ''
      : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiMerge, {
      path: pathPlusParams,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_MERGE_SCORE_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_MERGE_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_MERGE_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* postMergeAPIMergeDetails({ data }) {
  try {
    const res = yield retry(4, 500, authClient.IOC.mergeApiMergePost, {
      body: {
        [data?.fieldName]: data[data?.fieldName],
        ...(data?.secondFieldName && {
          [data?.secondFieldName]: data[data?.secondFieldName],
        }),
      },
      path: data.path,
    });
    yield put({
      type: resolve(types.POST_MERGE_API_MERGE_SCORE_DETAILS),
      payload: res.data(),
    });
  } catch (error) {
    console.log(error.toString());
    yield put({
      type: reject(types.POST_MERGE_API_MERGE_SCORE_DETAILS),
      error,
    });
  }
}

export function* loadMergeAPIRiskScores({ data }) {
  try {
    let payload = {};
    // merge API limit the payload by 100, so we have to request 100s by 100s
    for (let offset = 0; offset < data?.observables?.length; offset += 99) {
      let slice = data?.observables?.slice(offset, offset + 99);
      //const res = yield call(authClient.IOC.loadMergeAPIRiskScores, {
      const res = yield retry(4, 500, authClient.IOC.loadMergeAPIRiskScores, {
        body: { observables: slice },
      });
      payload = { ...payload, ...res.data() };
    }

    yield put({
      type: resolve(types.LOAD_MERGE_API_RISK_SCORES),
      payload: payload,
    });
  } catch (error) {
    console.log(error.toString());
    yield put({
      type: reject(types.LOAD_MERGE_API_RISK_SCORES),
      error,
    });
  }
}

export function* loadMergeAPIASNDetails({ data }) {
  try {
    const res = yield retry(4, 500, authClient.IOC.loadMergeAPIASNDetails, {
      body: data,
    });
    yield put({
      type: resolve(types.LOAD_MERGE_API_ASN_DETAILS),
      payload: res.data(),
    });
  } catch (error) {
    console.log(error.toString());
    yield put({
      type: reject(types.LOAD_MERGE_API_ASN_DETAILS),
      error,
    });
  }
}

export function* loadHistoryQueries(page, urlFilter, hoursFilter, sort, users) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadHistoryQueries,
      page,
      urlFilter,
      hoursFilter,
      sort,
      users,
    );
    yield put({
      type: resolve(types?.LOAD_HISTORY_QUERIES),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_HISTORY_QUERIES),
      error,
    });
  }
}

export function* updateHistoryQuery(data) {
  try {
    yield put({
      type: resolve(types?.UPDATE_HISTORY_QUERY),
      payload: data,
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.UPDATE_HISTORY_QUERY),
      error,
    });
  }
}

export function* addNewHistoryQuery(data) {
  try {
    yield put({
      type: resolve(types?.ADD_NEW_HISTORY_QUERY),
      payload: data,
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.ADD_NEW_HISTORY_QUERY),
      error,
    });
  }
}

export function* loadHistoryQueryResult({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadHistoryQueryResult, {
      uuid,
    });
    yield put({
      type: resolve(types?.LOAD_HISTORY_QUERY_RESULT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_HISTORY_QUERY_RESULT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_HISTORY_QUERY_RESULT),
        ),
      }),
    ]);
  }
}

export function* copyHistoryQueryResult({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.copyHistoryQueryResult, {
      uuid,
    });
    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.COPY_HISTORY_QUERY_RESULT),
        payload: res?.data(),
      });
    }
  } catch (error) {
    yield all([
      put({
        type: reject(types?.COPY_HISTORY_QUERY_RESULT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.COPY_HISTORY_QUERY_RESULT),
        ),
      }),
    ]);
  }
}

export function* clearCopyHistoryQueryResult() {
  try {
    //const res = yield retry(4, 500, authClient.IOC.details, {});
    yield put({
      type: resolve(types?.CLEAR_COPY_HISTORY_QUERY_RESULT),
      //payload: res.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.CLEAR_COPY_HISTORY_QUERY_RESULT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.CLEAR_COPY_HISTORY_QUERY_RESULT),
        ),
      }),
    ]);
  }
}

export function* downloadHistoryQueryResult({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.downloadHistoryQueryResult,
      {
        uuid,
      },
    );
    const response = res?.data();
    yield put({
      type: resolve(types?.DOWNLOAD_HISTORY_QUERY_RESULT),
      //payload: res?.data(),
    });

    const fileBlob = new Blob([response], {
      type: 'text/csv',
    });

    const fileName = `${uuid}.txt`;

    saveAs(fileBlob, fileName);
  } catch (error) {
    yield all([
      put({
        type: reject(types?.DOWNLOAD_HISTORY_QUERY_RESULT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.DOWNLOAD_HISTORY_QUERY_RESULT),
        ),
      }),
    ]);
  }
}

export function* loadMonitoringFile({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadMonitoringFile, {
      uuid,
    });
    const response = res?.data();
    yield put({
      type: resolve(types?.LOAD_MONITORING_FILE),
      //payload: res?.data(),
    });
    const csvBlob = new Blob([response], {
      type: 'text/csv',
    });

    saveAs(
      csvBlob,
      'monitoring_export_' +
        moment()?.format('YYYY-MM-DD_HHmmss')?.toString() +
        '.csv',
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MONITORING_FILE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MONITORING_FILE),
        ),
      }),
    ]);
  }
}

export function* loadMonitoringJSONFile({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadMonitoringJSONFile, {
      uuid,
    });
    //const response = res?.data();
    yield put({
      type: resolve(types?.LOAD_MONITORING_JSON_FILE),
      payload: res?.data(),
    });
    // const csvBlob = new Blob([response], {
    //   type: 'text/csv',
    // });

    // saveAs(
    //   csvBlob,
    //   'monitoring_export_' +
    //     moment()?.format('YYYY-MM-DD_HHmmss')?.toString() +
    //     '.csv',
    // );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MONITORING_JSON_FILE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MONITORING_JSON_FILE),
        ),
      }),
    ]);
  }
}

export function* saveMonitoringQuery({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.saveMonitoringQuery, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MONITORING_QUERY),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Monitoring Saved Successfully.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MONITORING_QUERY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Monitoring save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MONITORING_QUERY),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Monitoring Saved.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MONITORING_QUERY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MONITORING_QUERY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* updateMonitoringQuery({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.updateMonitoringQuery, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MONITORING_QUERY),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Monitoring Updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MONITORING_QUERY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Monitoring update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MONITORING_QUERY),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Monitoring Updated.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MONITORING_QUERY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MONITORING_QUERY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMonitoringQueries({ page }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadMonitoringQueries, {
      page,
    });
    yield put({
      type: resolve(types?.LOAD_MONITORING_QUERIES),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_MONITORING_QUERIES),
      error,
    });
  }
}

export function* deleteMonitoringQuery({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.deleteMonitoringQuery, {
      uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MONITORING_QUERY),
        uuid: uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Monitoring Deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MONITORING_QUERY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Monitoring delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MONITORING_QUERY),
  //     uuid: uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Monitoring Deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MONITORING_QUERY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MONITORING_QUERY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMonitoringQuery({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeMonitoringQuery,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SCOPE_MONITORING_QUERY),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Monitoring Updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_SCOPE_MONITORING_QUERY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Monitoring update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MONITORING_QUERY),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Monitoring Updated.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_MONITORING_QUERY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MONITORING_QUERY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* runMonitoringQuery({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.runMonitoringQuery, {
      uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.RUN_MONITORING_QUERY),
        uuid: uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Monitoring Query has been rerun successfully',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.RUN_MONITORING_QUERY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Monitoring query rerun was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  // yield put({
  //   type: resolve(types?.RUN_MONITORING_QUERY),
  //   uuid: uuid,
  // });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Monitoring Query has been rerun successfully',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.RUN_MONITORING_QUERY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.RUN_MONITORING_QUERY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMonitoringQueryResultsHistory({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadMonitoringQueryResultsHistory,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MONITORING_QUERY_RESULTS_HISTORY),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_MONITORING_QUERY_RESULTS_HISTORY),
      error,
    });
  }
}

export function* loadMergeAPIExploreQueryBuilderSchemas() {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreQueryBuilderSchemas,
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMAS),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMAS),
      error,
    });
  }
}

export function* loadMergeAPIExploreQueryBuilderSchema({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreQueryBuilderSchema,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
      error,
    });
  }
}

export function* saveMergeAPIExploreQueryBuilderSchema({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreQueryBuilderSchema,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Query Saved',
        }),
      );
      yield put(loadMergeAPIExploreQueryBuilderSchemasAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Query save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Query Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreQueryBuilderSchemasAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreQueryBuilderSchema({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreQueryBuilderSchema,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
        uuid: uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Query Deleted',
        }),
      );
      yield put(loadMergeAPIExploreQueryBuilderSchemasAction());
      history.push('/explore');
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Query delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
  //     uuid: uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Query Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreQueryBuilderSchemasAction());
  //   history.push('/explore');
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreQueryBuilderSchema({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreQueryBuilderSchema,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Query Updated',
        }),
      );
      yield put(loadMergeAPIExploreQueryBuilderSchemasAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Query update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
  //     payload: res?.data(),
  //   });
  //   yield put(loadMergeAPIExploreQueryBuilderSchemasAction());
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Query Updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipes() {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadExploreRecipes);
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPES),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPES),
      error,
    });
  }
}

export function* loadAttackSurfaceMapping() {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadAttackSurfaceMapping);
    yield put({
      type: resolve(types?.LOAD_ATTACK_SURFACE_MAPPING),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_ATTACK_SURFACE_MAPPING),
      error,
    });
  }
}

export function* loadDigitalThreatManagement() {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadDigitalThreatManagement,
    );
    yield put({
      type: resolve(types?.LOAD_DIGITAL_THREAT_MANAGEMENT),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_DIGITAL_THREAT_MANAGEMENT),
      error,
    });
  }
}

export function* loadMergeAPIExploreRecipe({ path }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadExploreRecipe, {
      path,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE),
        ),
      }),
    ]);
  }
}

export function* deleteMergeAPIExploreRecipeForwardA({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeForwardA,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeForwardA({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeForwardA,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeForwardA({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeForwardA,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeForwardA({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeForwardA,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeForwardA({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeForwardA,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeHostingInfraIPs({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeHostingInfraIPs,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeHostingInfraIPs({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeHostingInfraIPs,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeHostingInfraIPs({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeHostingInfraIPs,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeHostingInfraIPs({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeHostingInfraIPs,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeHostingInfraIPs({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeHostingInfraIPs,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeNameServerChanges({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeNameServerChanges,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeNameServerChanges({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeNameServerChanges,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeNameServerChanges({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeNameServerChanges,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeNameServerChanges({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeNameServerChanges,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeNameServerChanges({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeNameServerChanges,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeTXT({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.deleteExploreRecipeTXT, {
      uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_TXT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_TXT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_TXT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_TXT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_TXT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeTXT({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.loadExploreRecipeTXT, {
      uuid,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_TXT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_TXT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_TXT),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeTXT({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.updateExploreRecipeTXT, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeTXT({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.saveExploreRecipeTXT, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_TXT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_TXT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_TXT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_TXT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_TXT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeTXT({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeTXT,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeHostingInfrastructureASNs({
  uuid,
}) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeHostingInfrastructureASNs,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeHostingInfrastructureASNs({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeHostingInfrastructureASNs,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(
        types?.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
      ),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(
          types?.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
        ),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(
            types?.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
          ),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeHostingInfrastructureASNs({
  data,
}) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeHostingInfrastructureASNs,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeHostingInfrastructureASNs({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeHostingInfrastructureASNs,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeHostingInfrastructureASNs({
  data,
}) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeHostingInfrastructureASNs,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeDanglingDNSRecordsCount({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeDanglingDNSRecordsCount,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeDanglingDNSRecordsCount({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeDanglingDNSRecordsCount,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(
        types?.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
      ),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(
          types?.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
        ),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(
            types?.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
          ),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeDanglingDNSRecordsCount({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeDanglingDNSRecordsCount,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeDanglingDNSRecordsCount({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeDanglingDNSRecordsCount,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeDanglingDNSRecordsCount({
  data,
}) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeDanglingDNSRecordsCount,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeDanglingDNSProtection({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeDanglingDNSProtection,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeDanglingDNSProtection({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeDanglingDNSProtection,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(
        types?.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
      ),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(
          types?.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
        ),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeDanglingDNSProtection({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeDanglingDNSProtection,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeDanglingDNSProtection({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeDanglingDNSProtection,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeDanglingDNSProtection({
  data,
}) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeDanglingDNSProtection,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeIPDiversity({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeIPDiversity,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeIPDiversity({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeIPDiversity,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeIPDiversity({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeIPDiversity,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeIPDiversity({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeIPDiversity,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeIPDiversity({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeIPDiversity,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeLatestDNSRecords({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeLatestDNSRecords,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeLatestDNSRecords({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeLatestDNSRecords,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeLatestDNSRecords({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeLatestDNSRecords,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeLatestDNSRecords({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeLatestDNSRecords,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeLatestDNSRecords({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeLatestDNSRecords,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeSubdomainFinder({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeSubdomainFinder,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeSubdomainFinder({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeSubdomainFinder,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeSubdomainFinder({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeSubdomainFinder,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeSubdomainFinder({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeSubdomainFinder,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeSubdomainFinder({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeSubdomainFinder,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeShadowIT({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeShadowIT,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeShadowIT({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeShadowIT,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeShadowIT({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeShadowIT,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeShadowIT({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeShadowIT,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeShadowIT({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeShadowIT,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeReverseA({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeReverseA,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
        ),
      }),
    ]);
  }
}

export function* deleteMergeAPIExploreRecipeReverseA({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeReverseA,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* updateMergeAPIExploreRecipeReverseA({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeReverseA,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeReverseA({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeReverseA,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeReverseA({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeReverseA,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeDomainsOnServer({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeDomainsOnServer,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
        ),
      }),
    ]);
  }
}

export function* deleteMergeAPIExploreRecipeDomainsOnServer({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeDomainsOnServer,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* updateMergeAPIExploreRecipeDomainsOnServer({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeDomainsOnServer,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeDomainsOnServer({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeDomainsOnServer,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeDomainsOnServer({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeDomainsOnServer,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeSpoofing({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeSpoofing,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING),
        ),
      }),
    ]);
  }
}

export function* deleteMergeAPIExploreRecipeSpoofing({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeSpoofing,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadDigitalThreatManagementAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadDigitalThreatManagementAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* updateMergeAPIExploreRecipeSpoofing({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeSpoofing,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadDigitalThreatManagementAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadDigitalThreatManagementAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeSpoofing({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeSpoofing,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message:
            data?.scope === 'ORGANISATION'
              ? 'Your recipe has been shared with your organization'
              : 'Your recipe has been unshared with your organization',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadDigitalThreatManagementAction());
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadDigitalThreatManagementAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteMergeAPIExploreRecipeNameInTXT({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.deleteExploreRecipeNameInTXT,
      {
        uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Deleted',
        }),
      );
      yield put(loadDigitalThreatManagementAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe delete was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Deleted',
  //     }),
  //   );
  //   yield put(loadDigitalThreatManagementAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadMergeAPIExploreRecipeNameInTXT({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadExploreRecipeNameInTXT,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
        ),
      }),
    ]);
  }
}

export function* updateMergeAPIExploreRecipeNameInTXT({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.updateExploreRecipeNameInTXT,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadDigitalThreatManagementAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadDigitalThreatManagementAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveMergeAPIExploreRecipeNameInTXT({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeNameInTXT,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadDigitalThreatManagementAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadDigitalThreatManagementAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* changeScopeMergeAPIExploreRecipeNameInTXT({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.changeScopeExploreRecipeNameInTXT,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Updated',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadDigitalThreatManagementAction());
    } else {
      yield all([
        put({
          type: reject(
            types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Updated',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadDigitalThreatManagementAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* queryNameInTXTRecipe({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.queryNameInTXTRecipe, {
      body: data,
    });
    yield put({
      type: resolve(types?.QUERY_NAME_IN_TXT_RECIPE),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.QUERY_NAME_IN_TXT_RECIPE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.QUERY_NAME_IN_TXT_RECIPE),
        ),
      }),
    ]);
  }
}

export function* cloneRecipe({ data, name, uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.cloneGeneralExploreRecipe,
      {
        body: data,
        name: name,
        uuid: uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CLONE_RECIPE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadDigitalThreatManagementAction());
      yield put(loadAttackSurfaceMappingAction());
    } else {
      yield all([
        put({
          type: reject(types?.CLONE_RECIPE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CLONE_RECIPE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadDigitalThreatManagementAction());
  //   yield put(loadAttackSurfaceMappingAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CLONE_RECIPE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.CLONE_RECIPE)),
  //     }),
  //   ]);
  // }
}

export function* loadIOCSFromSpecificCollection({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadIOCSFromSpecificCollection,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_IOCS_FROM_SPECIFIC_COLLECTION),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_IOCS_FROM_SPECIFIC_COLLECTION),
      error,
    });
  }
}

export function* loadIOCSPageFromSpecificCollection({ uuid, page }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadIOCSPageFromSpecificCollection,
      {
        uuid,
        page,
      },
    );
    yield put({
      type: resolve(types?.LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION),
      error,
    });
  }
}

export function* loadIOCSFromSpecificSharedCollection({ uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadIOCSFromSpecificSharedCollection,
      {
        uuid,
      },
    );
    yield put({
      type: resolve(types?.LOAD_IOCS_FROM_SPECIFIC_SHARED_COLLECTION),
      payload: res?.data(),
    });
  } catch (error) {
    console.log(error?.toString());
    yield put({
      type: reject(types?.LOAD_IOCS_FROM_SPECIFIC_SHARED_COLLECTION),
      error,
    });
  }
}

export function* saveMergeAPIExploreRecipeSpoofing({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.saveExploreRecipeSpoofing,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Recipe Saved',
        }),
      );
      yield put(loadMergeAPIExploreRecipesAction());
      yield put(loadDigitalThreatManagementAction());
    } else {
      yield all([
        put({
          type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Recipe save was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Recipe Saved',
  //     }),
  //   );
  //   yield put(loadMergeAPIExploreRecipesAction());
  //   yield put(loadDigitalThreatManagementAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING),
  //       ),
  //     }),
  //   ]);
  // }
}

//this is unused, anyIP queries are using the ANYIPV4 query
export function* loadMergeAPIExploreAnyIPDetails({
  path1,
  path2,
  exploreFilters,
  exploreSorting,
}) {
  // console.log('path1', path1?.path1);
  // console.log('path2', path1?.path2);
  // console.log('exploreFiltersFromSaga', path1?.exploreFilters);
  // console.log('exploreSortingFromSaga', path1?.exploreSorting);
  let path1PlusParams = path1?.path1;
  let path2PlusParams = path1?.path2;
  if (path1?.exploreFilters?.['last_seen_from']) {
    path1PlusParams =
      path1PlusParams +
      (path1PlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path1?.exploreFilters?.['last_seen_from']?.substr(0, 10);
    path2PlusParams =
      path2PlusParams +
      (path2PlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path1?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path1?.exploreFilters?.['last_seen_to']) {
    path1PlusParams =
      path1PlusParams +
      (path1PlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path1?.exploreFilters?.['last_seen_to']?.substr(0, 10);
    path2PlusParams =
      path2PlusParams +
      (path2PlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path1?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path1?.exploreFilters?.['first_seen_from']) {
    path1PlusParams =
      path1PlusParams +
      (path1PlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path1?.exploreFilters?.['first_seen_from']?.substr(0, 10);
    path2PlusParams =
      path2PlusParams +
      (path2PlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path1?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path1?.exploreFilters?.['first_seen_to']) {
    path1PlusParams =
      path1PlusParams +
      (path1PlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path1?.exploreFilters?.['first_seen_to']?.substr(0, 10);
    path2PlusParams =
      path2PlusParams +
      (path2PlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path1?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path1?.exploreSorting !== null &&
    path1?.exploreSorting !== undefined &&
    Object.keys(path1.exploreSorting)?.length !== 0
  ) {
    path1PlusParams =
      path1PlusParams +
      (path1PlusParams.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(path1?.exploreSorting);
    path2PlusParams =
      path2PlusParams +
      (path2PlusParams.includes('?') ? '&' : '?') +
      'sort=' +
      encodeURIComponent(path1?.exploreSorting);
  }

  // path1PlusParams = path1PlusParams +
  // (path1PlusParams.includes('?') ? '&' : '?') +
  // 'max_wait=25';

  // path2PlusParams = path2PlusParams +
  // (path2PlusParams.includes('?') ? '&' : '?') +
  // 'max_wait=25';

  path1PlusParams =
    path1PlusParams +
    (path1PlusParams.includes('with_metadata')
      ? ''
      : (path1PlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  path2PlusParams =
    path2PlusParams +
    (path2PlusParams.includes('with_metadata')
      ? ''
      : (path2PlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res1 = yield retry(4, 500, authClient?.IOC?.mergeApiExplore, {
      // path: path1,
      path: path1PlusParams,
    });
    const res2 = yield retry(4, 500, authClient?.IOC?.mergeApiExplore, {
      //path: path2,
      path: path2PlusParams,
    });
    let anyIPresponseData = [
      ...res1.data().response.records,
      ...res2.data().response.records,
    ];

    let anyIPjobID = res1.data()?.response?.job_status?.job_id;

    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS),
      payload: anyIPresponseData,
      jobID: anyIPjobID,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadMergeAPIExploreIPDensityDetails({ path }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiExplore, {
      path,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS),
        ),
      }),
    ]);
  }
}

export function* deleteIOCNote({ iocUUID, noteUUID }) {
  try {
    const res = yield retry(4, 500, authClient.IOC.deleteIOCNote, {
      iocUUID,
      noteUUID,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_IOC_NOTE),
        payload: noteUUID,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Note Deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_IOC_NOTE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Deleting note was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types.DELETE_IOC_NOTE),
  //     payload: noteUUID,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Note Deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types.DELETE_IOC_NOTE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types.DELETE_IOC_NOTE)),
  //     }),
  //   ]);
  // }
}

export function* updateIOCNote({ iocUUID, noteUUID, noteDescription }) {
  try {
    const res = yield retry(4, 500, authClient.IOC.updateIOCNote, {
      iocUUID,
      noteUUID,
      body: {
        note: noteDescription,
      },
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_IOC_NOTE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Note Updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_IOC_NOTE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Updating note was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types.UPDATE_IOC_NOTE),
  //     payload: res.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Note Updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types.UPDATE_IOC_NOTE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types.UPDATE_IOC_NOTE)),
  //     }),
  //   ]);
  // }
}

export function* createIOCNote({ iocUUID, feedUUID, noteDescription }) {
  try {
    const res = yield retry(4, 500, authClient.IOC.createIOCNote, {
      uuid: iocUUID,
      body: {
        note: noteDescription,
        //ioc_uuid: iocUUID,
        //user_feed_uuid: feedUUID,
      },
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_IOC_NOTE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Note Created',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_IOC_NOTE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Creating note was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types.CREATE_IOC_NOTE),
  //     payload: res.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Note Created',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types.CREATE_IOC_NOTE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types.CREATE_IOC_NOTE)),
  //     }),
  //   ]);
  // }
}

export function* loadIOCNotes({ iocUUID, feedUUID }) {
  try {
    const res = yield retry(4, 500, authClient.IOC.loadIOCNotes, {
      iocUUID,
      // feedUUID,
    });
    yield put({
      type: resolve(types.LOAD_IOC_NOTES),
      payload: res.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.LOAD_IOC_NOTES),
        error,
      }),
      put({
        type: NOTIFICATION.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.LOAD_IOC_NOTES)),
      }),
    ]);
  }
}

export function* loadMergeAPIDensityDetails({ path }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiExplore, {
      path,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadMergeAPIWhoisDetails({ path }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.mergeApiExplore, {
      path,
    });
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS),
        ),
      }),
    ]);
  }
}

export function* loadMergeAPIWhoisFallbackDetails({ path }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadMergeAPIWhoisFallbackDetails,
      {
        path,
      },
    );
    yield put({
      type: resolve(types?.LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS),
        ),
      }),
    ]);
  }
}

export function* toggleFalsePositive({ ioc }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.toggleFalsePositive, {
      ioc_uuid: ioc?.uuid,
      // feed: ioc?.feeds?.uuid,
      body: {
        false_positive: ioc?.false_positive,
      },
    });
    yield put({
      type: resolve(types?.TOGGLE_FALSE_POSITIVE),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.TOGGLE_FALSE_POSITIVE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.TOGGLE_FALSE_POSITIVE),
        ),
      }),
    ]);
  }
}

export function* toggleTruePositive({ ioc }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.toggleTruePositive, {
      ioc_uuid: ioc?.uuid,
      // feed: ioc?.feeds?.uuid,
      body: {
        true_positive: ioc?.true_positive,
      },
    });
    yield put({
      type: resolve(types?.TOGGLE_TRUE_POSITIVE),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.TOGGLE_TRUE_POSITIVE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.TOGGLE_TRUE_POSITIVE),
        ),
      }),
    ]);
  }
}

export function* createIOC({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.create, {
      body: data,
      uuid: data?.feed_uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_IOC),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'The observable has been added to the source.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_IOC),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Adding the observable was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_IOC),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'The observable has been added to the source.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_IOC),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.CREATE_IOC)),
  //     }),
  //   ]);
  // }
}

export function* deleteIOC({ uuid, feed }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.delete, {
      uuid,
      feed,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_IOC),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'IOC has been deleted from Feed.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_IOC),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Deleting IOC was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_IOC),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'IOC has been deleted from Feed.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_IOC),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.DELETE_IOC)),
  //     }),
  //   ]);
  // }
}

export function* deleteIOCFromCollection({ uuid, feed }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.deleteIOCFromCollection, {
      uuid,
      feed,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_IOC_FROM_COLLECTION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'IOC has been deleted from Source.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_IOC_FROM_COLLECTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Deleting IOC was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_IOC_FROM_COLLECTION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'IOC has been deleted from Source.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_IOC_FROM_COLLECTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_IOC_FROM_COLLECTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* saveBreadCrumbs({ data }) {
  try {
    //const res = yield retry(4, 500, authClient.IOC.details, {});
    yield put({
      type: resolve(types?.SAVE_BREADCRUMBS),
      payload: data,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.SAVE_BREADCRUMBS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.SAVE_BREADCRUMBS)),
      }),
    ]);
  }
}

export function* loadBrandImpersonationRecipeResults({ path, exploreFilters }) {
  let pathPlusParams = path?.path;

  // console.log('exploreFilters', exploreFilters);
  // console.log('path', path);
  // console.log('begin', pathPlusParams);
  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  /*
  NOT FULLY SUPPORTED: URLParams.size
  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/size
   */
  if (URLParams?.size > 0 || URLParams.toString() !== '') {
    pathPlusParams = finalURLPathName + '?' + URLParams?.toString();
  } else {
    pathPlusParams = finalURLPathName;
  }

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    // console.log('exploresort', path?.exploreSorting);

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort_by');
    URLParams.delete('order_by');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();
    // console.log('assembledURL', assembledURLForExplore);
    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort_by=' +
      path?.exploreSorting?.split('/')?.[0] +
      '&order_by=' +
      path?.exploreSorting?.split('/')?.[1];
    //encodeURIComponent(path?.exploreSorting);
  }
  // console.log('pathPlusParams', pathPlusParams);
  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('max_wait')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('with_metadata')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadBrandImpersonationRecipeResults,
      {
        path: pathPlusParams,
        // body: data,
      },
    );
    yield put({
      type: resolve(types?.LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS),
        ),
      }),
    ]);
  }
}

export function* loadDanglingDNSDetectionRecipeResults({
  path,
  exploreFilters,
}) {
  let pathPlusParams = path?.path;

  // console.log('exploreFilters', exploreFilters);
  // console.log('path', path);
  // console.log('begin', pathPlusParams);
  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  /*
  NOT FULLY SUPPORTED: URLParams.size
  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/size
   */
  if (URLParams?.size > 0 || URLParams.toString() !== '') {
    pathPlusParams = finalURLPathName + '?' + URLParams?.toString();
  } else {
    pathPlusParams = finalURLPathName;
  }

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    // console.log('exploresort', path?.exploreSorting);

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort_by');
    URLParams.delete('order_by');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();
    // console.log('assembledURL', assembledURLForExplore);
    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort_by=' +
      path?.exploreSorting?.split('/')?.[0] +
      '&order_by=' +
      path?.exploreSorting?.split('/')?.[1];
    //encodeURIComponent(path?.exploreSorting);
  }
  // console.log('pathPlusParams', pathPlusParams);
  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('max_wait')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('with_metadata')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadDanglingDNSDetectionRecipeResults,
      {
        path: pathPlusParams,
        // body: data,
      },
    );
    yield put({
      type: resolve(types?.LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS),
        ),
      }),
    ]);
  }
}

export function* loadHostingInfrastructureASNsRecipeResults({
  path,
  exploreFilters,
}) {
  let pathPlusParams = path?.path;

  // console.log('exploreFilters', exploreFilters);
  // console.log('path', path);
  // console.log('begin', pathPlusParams);
  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  /*
  NOT FULLY SUPPORTED: URLParams.size
  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/size
   */
  if (URLParams?.size > 0 || URLParams.toString() !== '') {
    pathPlusParams = finalURLPathName + '?' + URLParams?.toString();
  } else {
    pathPlusParams = finalURLPathName;
  }

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    // console.log('exploresort', path?.exploreSorting);

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort_by');
    URLParams.delete('order_by');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();
    // console.log('assembledURL', assembledURLForExplore);
    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort_by=' +
      path?.exploreSorting?.split('/')?.[0] +
      '&order_by=' +
      path?.exploreSorting?.split('/')?.[1];
    //encodeURIComponent(path?.exploreSorting);
  }
  // console.log('pathPlusParams', pathPlusParams);
  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('max_wait')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('with_metadata')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadHostingInfrastructureASNsRecipeResults,
      {
        path: pathPlusParams,
        // body: data,
      },
    );
    yield put({
      type: resolve(types?.LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS),
        ),
      }),
    ]);
  }
}

export function* loadSubdomainFinderRecipeResults({ path, exploreFilters }) {
  let pathPlusParams = path?.path;

  // console.log('exploreFilters', exploreFilters);
  // console.log('path', path);
  // console.log('begin', pathPlusParams);
  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  /*
  NOT FULLY SUPPORTED: URLParams.size
  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/size
   */
  if (URLParams?.size > 0 || URLParams.toString() !== '') {
    pathPlusParams = finalURLPathName + '?' + URLParams?.toString();
  } else {
    pathPlusParams = finalURLPathName;
  }

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    // console.log('exploresort', path?.exploreSorting);

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort_by');
    URLParams.delete('order_by');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();
    // console.log('assembledURL', assembledURLForExplore);
    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort_by=' +
      path?.exploreSorting?.split('/')?.[0] +
      '&order_by=' +
      path?.exploreSorting?.split('/')?.[1];
    //encodeURIComponent(path?.exploreSorting);
  }
  // console.log('pathPlusParams', pathPlusParams);
  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('max_wait')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('with_metadata')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadSubdomainFinderRecipeResults,
      {
        path: pathPlusParams,
        // body: data,
      },
    );
    yield put({
      type: resolve(types?.LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS),
        ),
      }),
    ]);
  }
}

export function* loadShadowITRecipeResults({ path, exploreFilters }) {
  let pathPlusParams = path?.path;

  // console.log('exploreFilters', exploreFilters);
  // console.log('path', path);
  // console.log('begin', pathPlusParams);
  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  /*
  NOT FULLY SUPPORTED: URLParams.size
  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/size
   */
  if (URLParams?.size > 0 || URLParams.toString() !== '') {
    pathPlusParams = finalURLPathName + '?' + URLParams?.toString();
  } else {
    pathPlusParams = finalURLPathName;
  }

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    // console.log('exploresort', path?.exploreSorting);

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort_by');
    URLParams.delete('order_by');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();
    // console.log('assembledURL', assembledURLForExplore);
    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort_by=' +
      path?.exploreSorting?.split('/')?.[0] +
      '&order_by=' +
      path?.exploreSorting?.split('/')?.[1];
    //encodeURIComponent(path?.exploreSorting);
  }
  // console.log('pathPlusParams', pathPlusParams);
  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('max_wait')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('with_metadata')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadShadowITRecipeResults,
      {
        path: pathPlusParams,
        // body: data,
      },
    );
    yield put({
      type: resolve(types?.LOAD_SHADOW_IT_RECIPE_RESULTS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_SHADOW_IT_RECIPE_RESULTS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_SHADOW_IT_RECIPE_RESULTS),
        ),
      }),
    ]);
  }
}

export function* loadHostingInfrastructureIPsRecipeResults({
  path,
  exploreFilters,
}) {
  let pathPlusParams = path?.path;

  // console.log('exploreFilters', exploreFilters);
  // console.log('path', path);
  // console.log('begin', pathPlusParams);
  //delete first seen, last seen params if there's more than one
  //only keep the new one passed
  let pathURL = new URL(pathPlusParams, 'https://silentpush.com');
  let URLParams = new URLSearchParams(pathURL.search);

  if (
    path?.exploreFilters?.['last_seen_from']?.substr(0, 10) &&
    URLParams.getAll('last_seen_after')?.[0] !==
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_from']?.substr(0, 10) &&
    URLParams.getAll('first_seen_after')?.[0] !==
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_after');
  }

  if (
    path?.exploreFilters?.['first_seen_to'] &&
    URLParams.getAll('first_seen_before')?.[0] !==
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('first_seen_before');
  }

  if (
    path?.exploreFilters?.['last_seen_to'] &&
    URLParams.getAll('last_seen_before')?.[0] !==
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10)
  ) {
    URLParams.delete('last_seen_before');
  }

  let finalURLPathName =
    pathURL?.pathname?.toString()?.charAt(0) === '/'
      ? pathURL?.pathname?.substring(1)
      : pathURL?.pathname;
  /*
  NOT FULLY SUPPORTED: URLParams.size
  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/size
   */
  if (URLParams?.size > 0 || URLParams.toString() !== '') {
    pathPlusParams = finalURLPathName + '?' + URLParams?.toString();
  } else {
    pathPlusParams = finalURLPathName;
  }

  if (path?.exploreFilters?.['last_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_after=' +
      path?.exploreFilters?.['last_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['last_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'last_seen_before=' +
      path?.exploreFilters?.['last_seen_to']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_from']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_after=' +
      path?.exploreFilters?.['first_seen_from']?.substr(0, 10);
  }
  if (path?.exploreFilters?.['first_seen_to']) {
    pathPlusParams =
      pathPlusParams +
      (pathPlusParams.includes('?') ? '&' : '?') +
      'first_seen_before=' +
      path?.exploreFilters?.['first_seen_to']?.substr(0, 10);
  }
  if (
    path?.exploreSorting !== null &&
    path?.exploreSorting !== undefined &&
    Object.keys(path.exploreSorting)?.length !== 0
  ) {
    //remove sorting if URL already has it, eg. from query Builder visualization, or from recipe
    //As that would always come first in the URL and override changes.

    // console.log('exploresort', path?.exploreSorting);

    let tempURL = new URL(pathPlusParams, 'https://silentpush.com');
    let URLParams = new URLSearchParams(tempURL.search);

    URLParams.delete('sort_by');
    URLParams.delete('order_by');

    let finalURLPathName =
      tempURL?.pathname?.toString()?.charAt(0) === '/'
        ? tempURL?.pathname?.substring(1)
        : tempURL?.pathname;
    let assembledURLForExplore = finalURLPathName + '?' + URLParams?.toString();
    // console.log('assembledURL', assembledURLForExplore);
    pathPlusParams =
      assembledURLForExplore +
      (assembledURLForExplore.includes('?') ? '&' : '?') +
      'sort_by=' +
      path?.exploreSorting?.split('/')?.[0] +
      '&order_by=' +
      path?.exploreSorting?.split('/')?.[1];
    //encodeURIComponent(path?.exploreSorting);
  }
  // console.log('pathPlusParams', pathPlusParams);
  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('max_wait')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'max_wait=25');

  // pathPlusParams =
  //   pathPlusParams +
  //   (pathPlusParams.includes('with_metadata')
  //     ? ''
  //     : (pathPlusParams.includes('?') ? '&' : '?') + 'with_metadata=1');

  try {
    const res = yield retry(
      4,
      500,
      authClient?.IOC?.loadHostingInfrastructureIPsRecipeResults,
      {
        path: pathPlusParams,
        // body: data,
      },
    );
    yield put({
      type: resolve(types?.LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS),
        ),
      }),
    ]);
  }
}
